var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryImageicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447717 0.447715 0 1 0H9.66667C10.219 0 10.6667 0.447715 10.6667 1V8.66667C10.6667 9.77123 9.77124 10.6667 8.66667 10.6667H2C0.895432 10.6667 0 9.77124 0 8.66667V1Z",
    fill: "#28AF4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.3333C13.3334 13.781 13.7811 13.3333 14.3334 13.3333H23C23.5523 13.3333 24 13.781 24 14.3333V22C24 23.1046 23.1046 24 22 24H15.3334C14.2288 24 13.3334 23.1046 13.3334 22V14.3333Z",
    fill: "#28AF4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.3333C0 15.1242 1.79086 13.3333 4 13.3333H6.66666C8.8758 13.3333 10.6667 15.1242 10.6667 17.3333V20C10.6667 22.2091 8.87581 24 6.66667 24H4C1.79086 24 0 22.2091 0 20V17.3333Z",
    fill: "#28AF4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 4C13.3334 1.79086 15.1242 0 17.3334 0H20C22.2092 0 24 1.79086 24 4V6.66666C24 8.8758 22.2092 10.6667 20 10.6667H17.3334C15.1242 10.6667 13.3334 8.87581 13.3334 6.66667V4Z",
    fill: "#28AF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryImageicon);
export default __webpack_public_path__ + "static/media/CategoryImageicon.081994cb65dd7ebf85aca9b8b58799d9.svg";
export { ForwardRef as ReactComponent };